import React, { ReactElement } from 'react';
import { StyledCustomButton } from './CustomButton.styles';
import { LockFilled } from '@ant-design/icons';
const defaultProps = {};
type CustomButtonProps = {
	title: string;
	onClick: () => void;
} & typeof defaultProps;

export const CustomButton = ({
	title,
	onClick
}: CustomButtonProps): ReactElement => {
	return (
		<StyledCustomButton onClick={onClick}>
			<LockFilled /> &nbsp; {title}
		</StyledCustomButton>
	);
};
CustomButton.defaultProps = defaultProps;
